export class MiniSerp {
    private readonly container: HTMLElement | null;
    private readonly _activeStyleClass = 'active';
    private readonly _targetAttributeName = 'data-tab-target';
    private readonly _containerSelector = '.js-mini-serp-container';
    private _hasShownFirstTabWithResults = false;

    constructor() {
        this.container = document.querySelector(this._containerSelector)
    }

    init() {
        if (!this.container) {
            return;
        }
        this.container.querySelectorAll(`[${this._targetAttributeName}]`).forEach((tabElement) => {
            if (tabElement instanceof HTMLElement && tabElement.dataset.totalUnits !== '0') {
                this.registerSwitchTabOnClickEvent(tabElement);
                this.showFirstTabWithResults(tabElement);
            }
        })
    }

    private showFirstTabWithResults(tabElement: HTMLElement) {
        if (!this._hasShownFirstTabWithResults) {
            this.switchTab(tabElement);
            this._hasShownFirstTabWithResults = true;
        }
    }

    private registerSwitchTabOnClickEvent(tabElement: Element) {
        tabElement.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const tabElement = event.currentTarget as HTMLElement;
            if (tabElement) {
                this.switchTab(tabElement);
            }
        });
    }

    private switchTab(tabElement: HTMLElement) {
        this.hideAllTabsAndTheirTargets();
        this.showTabAndItsTargets(tabElement);
    }

    private hideAllTabsAndTheirTargets() {
        this.container?.querySelectorAll(`[${this._targetAttributeName}]`).forEach((tabElement) => {
            this.deactiveTab(tabElement as HTMLElement);
            let tabTargets = tabElement.getAttribute(this._targetAttributeName)!!;
            this.hideTabTargets(tabTargets);
        });
    }

    private showTabAndItsTargets(tabElement: HTMLElement) {
        this.activeTab(tabElement);
        this.showTabTargets(tabElement);
    }

    private deactiveTab(tabElement: HTMLElement) {
        tabElement.classList.remove(this._activeStyleClass);
    }

    private hideTabTargets(tabTargets: any) {
        this.container?.querySelectorAll(tabTargets).forEach((target) => {
            target.classList.remove(this._activeStyleClass);
        })
    }

    private activeTab(tabElement: HTMLElement) {
        tabElement.classList.add(this._activeStyleClass);
    }

    private showTabTargets(tabElement: HTMLElement) {
        let tabTargets = tabElement.getAttribute(this._targetAttributeName)!!;
        this.container?.querySelectorAll(tabTargets).forEach((target) => {
            target.classList.add(this._activeStyleClass);
        });
    }
}
